<div
    class="d-flex flex-row button-container align-items-center"
    [class.disabled-button]="disabled"
    [ngClass]="size"
>
    @if (displayIcon("left")) {
        <eff-icon [icon]="icon" [size]="iconDimension"></eff-icon>
    }
    <span class="button-label">{{ text }}</span>
    @if (displayIcon("right")) {
        <eff-icon [icon]="icon" [size]="iconDimension"></eff-icon>
    }
</div>
